/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterXSmall = createReactComponent("letter-x-small", "IconLetterXSmall", [
  ["path", { d: "M10 8l4 8", key: "svg-0" }],
  ["path", { d: "M10 16l4 -8", key: "svg-1" }]
]);

export { IconLetterXSmall as default };
//# sourceMappingURL=IconLetterXSmall.js.map
